// removed by extract-text-webpack-plugin


/*****************
 ** WEBPACK FOOTER
 ** ./components/style/index.less
 ** module id = 8
 ** module chunks = 0
 **/